<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="6">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
                v-on="on"
                small
                dark
                color="primary"
                height="44"
                depressed
                @click="printPage()"
            >
              <v-icon>mdi-cloud-print-outline</v-icon>
            </v-btn>
          </template>
          <span>Ispis</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-data-table
            :headers="headers"
            :items="items"
            :loading="loading"
            :options.sync="options"
            :server-items-length="serverItemsLength"
            class="elevation-1"
            loading-text="Traženje..."
            hide-default-footer
        >
          <template v-slot:[`item.professors`]="{ item }">
            <div v-if="item">
              <div v-for="(prof, i) in item.professors" :key="i">{{prof.full_name}}<span v-if="i<item.professors.length-1">, </span></div>
<!--              {{item.professors}}-->
            </div>
          </template>
          <template v-slot:[`item.id`]="{ item }">
            <v-btn
                color="primary"
                class="text-none"
                depressed
                @click="openEdit(item)"
            >
              Dodijeli nastavnika
            </v-btn>
          </template>
          <template v-slot:no-data>
            <span> Za tražene pojmove nema rezultata pretrage. </span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-dialog v-model="editDialog" max-width="700" @click:outside="closeDialog">
      <v-card>
        <v-toolbar color="primary" dark class="elevation-0 mb-5">
          <v-toolbar-title>Dodijeli nastavnika</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-btn @click.native="closeDialog" dark icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-row v-for="(subject, index) in addedSubjects" :key="subject.id">
            <v-col cols="12" md="10">
              <v-row>
                <v-col cols="10" md="10">
                  <v-row>
                    <v-subheader style="height: auto;">Nastavnik:</v-subheader>
                  </v-row>
                  <v-row>
                    <v-col class="pt-2 pb-0">
                      <v-autocomplete
                          :items="teachers"
                          placeholder="Odaberite nastavnika"
                          item-value="id"
                          item-text="full_name"
                          height="44"
                          clearable
                          v-model="subject.id"
                          dense
                          hide-details
                          outlined
                          single-line
                          hide-no-data
                      >
                        <template slot="item" slot-scope="{ item }">
                          {{ item.full_name }} - {{ item.aai_email }}
                        </template>
                        <template slot="selection" slot-scope="{ item }">
                          {{ item.full_name }} - {{ item.aai_email }}
                        </template>
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="2" md="2">
                  <v-row>
                    <v-subheader style="height: auto;">Zamjena:</v-subheader>
                  </v-row>
                  <v-col class="pt-2 pb-0">
                    <v-checkbox v-model="subject.is_substitute"></v-checkbox>
                  </v-col>
                </v-col>
                  <v-col v-if="subject.is_substitute"  cols="6">
                    <v-row>
                      <v-subheader style="height: auto;">Od:</v-subheader>
                    </v-row>
                    <v-row>
                      <v-col class="pt-2 pb-0">
                        <v-menu
                            ref="menu_valid_from"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="subject.valid_from"
                                label="Od"
                                prepend-inner-icon="mdi-calendar"
                                readonly
                                height="44"
                                hide-details
                                dense
                                outlined
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                              ref="picker"
                              locale="hr"
                              v-model="subject.valid_from"
                              @input="menu_valid_from = false"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col v-if="subject.is_substitute" cols="6">
                    <v-row>
                      <v-subheader style="height: auto;">Do:</v-subheader>
                    </v-row>
                    <v-row>
                      <v-col class="pt-2 pb-0">
                        <v-menu
                            ref="menu_valid_to"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="subject.valid_to"
                                label="Do"
                                prepend-inner-icon="mdi-calendar"
                                readonly
                                height="44"
                                hide-details
                                dense
                                outlined
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                              ref="picker"
                              locale="hr"
                              v-model="subject.valid_to"
                              @input="menu_valid_to = false"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                  </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" md="2" class="d-flex align-end pb-6">
              <v-row class="align-end">
                <v-col class="pb-0 pt-0">
                  <v-btn
                      height="44"
                      style="min-width: 44px; width: 44px;"
                      class="red darken-2 elevation-0"
                      @click="deleteAdded(index)"
                  >
                    <v-icon color="white">mdi-close</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" class="py-1">
              <v-divider></v-divider>
            </v-col>
          </v-row>
          <v-row v-if="$checkPermission('department subject_teacher add')">
            <v-btn
                class="elevation-0 primary--text"
                text
                @click="addSubject()"
            > + Dodaj polje
            </v-btn>
          </v-row>
        </v-card-text>

        <!--        <v-card-text class="mt-6">-->
        <!--          <v-row>-->
        <!--            <v-col cols="12">-->
        <!--              <v-autocomplete-->
        <!--                  :items="teachers"-->
        <!--                  placeholder="Odaberite nastavnika"-->
        <!--                  item-value="id"-->
        <!--                  item-text="full_name"-->
        <!--                  height="44"-->
        <!--                  clearable-->
        <!--                  v-model="selectedTeacherId"-->
        <!--                  dense-->
        <!--                  hide-details-->
        <!--                  outlined-->
        <!--                  single-line-->
        <!--                  hide-no-data-->
        <!--              >-->
        <!--                <template slot="item" slot-scope="{ item }">-->
        <!--                  {{ item.full_name }} - {{ item.aai_email }}-->
        <!--                </template>-->
        <!--                <template slot="selection" slot-scope="{ item }">-->
        <!--                  {{ item.full_name }} - {{ item.aai_email }}-->
        <!--                </template>-->
        <!--              </v-autocomplete>-->
        <!--            </v-col>-->
        <!--            <v-col cols="12">-->
        <!--              <v-checkbox-->
        <!--                  label="Potreban drugi nastavnik?"-->
        <!--                  v-model="needAnotherTeacher"-->
        <!--              >-->
        <!--              </v-checkbox>-->
        <!--            </v-col>-->
        <!--            <v-col cols="12" v-if="needAnotherTeacher">-->
        <!--              <v-autocomplete-->
        <!--                  :items="teachers"-->
        <!--                  placeholder="Odaberite nastavnika"-->
        <!--                  item-value="id"-->
        <!--                  item-text="full_name"-->
        <!--                  height="44"-->
        <!--                  clearable-->
        <!--                  v-model="selectedSubstituteTeacherId"-->
        <!--                  dense-->
        <!--                  hide-details-->
        <!--                  outlined-->
        <!--                  single-line-->
        <!--                  hide-no-data-->
        <!--              >-->
        <!--                <template slot="item" slot-scope="{ item }">-->
        <!--                  {{ item.full_name }} - {{ item.aai_email }}-->
        <!--                </template>-->
        <!--                <template slot="selection" slot-scope="{ item }">-->
        <!--                  {{ item.full_name }} - {{ item.aai_email }}-->
        <!--                </template>-->
        <!--              </v-autocomplete>-->
        <!--            </v-col>-->
        <!--          </v-row>-->
        <!--        </v-card-text>-->

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="closeDialog" class="text-none" depressed large outlined
          >Odustani
          </v-btn
          >
          <v-btn
              color="primary"
              class="text-none"
              @click="updateSubjectTeachers"
              depressed
              large
          >Potvrdi
          </v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {serverBus} from "@/main";
import ApiV2 from "@/services/ApiV2";

export default {
  components: {},

  created() {
    if (localStorage.getItem("department-subjects")) {
      this.options = JSON.parse(localStorage.getItem("department-subjects"));
    }
    this.getTeachers();
  },

  methods: {
    toAddOptionalSubjects() {
      this.$navigate(
          `/admin/odjeljenje/pregled/${this.$route.params.odjeljenje_id}/predmeti`
      );
    },

    openEdit(departmentSubject) {
      console.log(departmentSubject)
      this.addedSubjects=[]
      departmentSubject.professors.forEach(item => {
        this.addedSubjects.push({id: item.id, valid_from: item.pivot.valid_from, valid_to: item.pivot.valid_to, is_substitute: item.pivot.is_substitute});
      })
      // this.addedSubjects =
      this.editDialog = true;
      this.departmentSubjectId = departmentSubject.id;
      this.selectedTeacherId = departmentSubject.professor_id;
      this.selectedSubstituteTeacherId =
          departmentSubject.substitute_professor_id;

      if (this.selectedSubstituteTeacherId) {
        this.needAnotherTeacher = true;
      }
    },

    getDataFromApi() {
      this.loading = true;

      ApiV2.get(
          `departments/${this.$route.params.odjeljenje_id}/departmentSubjects`,
          {
            params: {
              with: ["subject", "professor", "substituteProfessor", "professors"],
              perPage: -1,
            },
          }
      )
          .then((response) => {
            this.items = response.data.data;
            this.serverItemsLength = response.data.total;
          })
          .catch(() => {
            this.items = [];
          })
          .finally(() => {
            this.loading = false;
          });
    },

    closeDialog() {
      this.editDialog = false;
      this.selectedTeacherId = null;
      this.selectedSubstituteTeacherId = null;
      this.needAnotherTeacher = false;
      this.addedSubjects = [{id: null, valid_from: null, valid_to: null, is_substitute: false}]
    },

    getTeachers() {
      ApiV2.get(`users`, {
        params: {
          role: 6,
          perPage: -1,
        },
      }).then((response) => {
        this.teachers = response.data.data;
      });
    },

    updateSubjectTeacher() {
      ApiV2.put(`department_subjects/${this.departmentSubjectId}`, {
        professor_id: this.selectedTeacherId || null,
        substitute_professor_id: this.selectedSubstituteTeacherId || null,
      })
          .then(() => {
            this.closeDialog();
            this.getDataFromApi();

            serverBus.$emit("show-snackbar", true);
          })
          .catch(() => {
            serverBus.$emit("show-snackbar", false);
          });
    },

    updateSubjectTeachers() {
      let requestBody = {}

      this.addedSubjects.forEach(item => {
        Object.assign(requestBody, {
          [item.id]: {
            valid_to: item.valid_to,
            valid_from: item.valid_from,
            is_substitute: item.is_substitute
          }
        })
      });
      console.log(requestBody)
      ApiV2.post(`department_subjects/${this.departmentSubjectId}/professors`, {
        data: requestBody,
        method: 'sync'
      }).then(() => {
        this.closeDialog();
        this.getDataFromApi();

        serverBus.$emit("show-snackbar", true);
      }).catch(() => {
        serverBus.$emit("show-snackbar", false);
      });
    },

    printPage() {
      this.getCurrentTime();
      setTimeout(function () {
        window.print();
      }, 200);
    },

    getCurrentTime() {
      let today = new Date();
      this.currentTime = today.toLocaleString();
    },
    addSubject() {
      this.addedSubjects.push({id: null, valid_from: null, valid_to: null, is_substitute: false});
    },
    deleteAdded(index) {
      this.addedSubjects.splice(index, 1);
    },
  },

  computed: {
    headers() {
      let headers = [
        {text: "Predmet", value: "subject.title"},
        // { text: "Nastavnik (1)", value: "professor.full_name" },
        // { text: "Nastavnik (2)", value: "substitute_professor.full_name" },
        { text: 'Nastavnici', value: "professors" },
        {text: "Akcije", value: "id"},
      ];

      if (!this.$checkPermission("department subject_teacher add")) {
        headers.pop();
      }

      return headers;
    },
  },

  watch: {
    options: {
      handler() {
        localStorage.setItem(
            "department-subjects",
            JSON.stringify(this.options)
        );

        this.getDataFromApi();
      },
      deep: true,
    },

    menu_valid_from(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    menu_valid_to(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    }
  },

  data: function () {
    return {
      menu_valid_from: false,
      menu_valid_to: false,
      items: [],
      request: null,
      editDialog: false,
      teachers: [],
      selectedTeacherId: null,
      departmentSubjectId: null,
      selectedSubstituteTeacherId: null,
      needAnotherTeacher: false,
      addedSubjects: [
        {id: null, valid_from: null, valid_to: null, is_substitute: false}
      ],
      search: {
        phrase: null,
        field: null,
      },
      options: {
        itemsPerPage: 10,
      },
      loading: true,
      serverItemsLength: 0,
    };
  },
};
</script>
